module.exports = __webpack_public_path__ + "img/details-buisness.png?6f803d5896016728a588d2706dff4527";